import classNames from 'classnames';
import styles from './StepProgressBar.module.scss';

interface ProgressBarProps {
	totalSteps: number;
	currentStep: number;
}

const StepProgressBar = ({ totalSteps, currentStep }: ProgressBarProps) => {
	return (
		<div className={styles.container}>
			{Array.from({ length: totalSteps }, (_, index) => {
				const isActive = index < currentStep;
				return (
					<div
						key={index}
						className={classNames(styles.progressItem, { [styles.active]: isActive })}
					/>
				);
			})}
		</div>
	);
};

export default StepProgressBar;
